import { useField, useFormikContext } from "formik";
import React from "react";
import FormikAutocomplete from "./FormikAutocomplete";
import { FormikDatePicker } from "./FormikDatePicker";
import FormikSelect from "./FormikSelect";
import FormikTextField from "./FormikTextField";

export default function FormikFields({
  fieldName,
  fieldLabel,
  fieldType,
  options,
  disabled,
  isErrorField,
}) {
  const [field] = useField(fieldName);
  const { setFieldValue } = useFormikContext();
  const handleChange = (e, selectValue) => {
    if (e.target.value[0] !== " ") {
      setFieldValue(
        fieldName,
        fieldType === "autocomplete" ? selectValue : e.target.value
      );
    }
  };
  const validateOpeningDate = (openingDate) => {
    setFieldValue(fieldName, openingDate);
  };

  return (
    // For Select Autocomplete Field
    fieldType === "autocomplete" ? (
      <FormikAutocomplete
        disabled={disabled}
        name={fieldName}
        label={fieldLabel}
        type={fieldType}
        fieldValue={field}
        handleChange={handleChange}
        options={options}
      />
    ) : // For Select Text Field
    fieldType === "text" ||
      fieldType === "note" ||
      fieldType === "email" ||
      fieldType === "number" ||
      fieldType === "password" ||
      fieldType === "mobile" ? (
      <FormikTextField
        disabled={disabled}
        name={fieldName}
        label={fieldLabel}
        type={fieldType}
        fieldValue={field}
        handleChange={handleChange}
        isErrorField={isErrorField}
      />
    ) : // For Select Type Field
    fieldType === "select" ? (
      <FormikSelect
        disabled={disabled}
        label={fieldLabel}
        fieldValue={field}
        options={options}
        handleChange={handleChange}
      />
    ) : // For Select Date Field
    fieldType === "date" ||
      fieldType === "startDate" ||
      fieldType === "endDate" ? (
      <FormikDatePicker
        label={fieldLabel}
        onChange={validateOpeningDate}
        disabled={disabled}
        fieldValue={field}
      />
    ) : (
      ""
    )
  );
}
